<template>
  <el-date-picker style="width:100%;min-width:100px"
                  :value="getValue"
                  @input="setValue($event?[+$event[0],+$event[1]]:[null,null])"
                  :readonly="propertyMin.readonly||propertyMax.readonly"
                  type="datetimerange"
                  :placeholder="placeholder">
  </el-date-picker>
</template>

<script>

    import minMaxControlMixin from './minMaxControlMixin'

    export default {
      name:"el-date-time-picker-minmax-control",
      mixins: [minMaxControlMixin]
    }
</script>

<style scoped>

</style>
